import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listUsers } from "../actions/userActions";

export default function User({ getAll }) {
  const dispatch = useDispatch();
  const { loading, error, users } = useSelector((s) => s.userList);
  console.log(getAll);
  const getUsers = () => {
    dispatch(listUsers(getAll));
  };

  useEffect(() => {
    getUsers();
  }, [dispatch]);

  return loading ? (
    <option value="">Loading...</option>
  ) : users ? (
    users.map((recs) => (
      <option key={recs.Id} value={recs.Id}>
        {recs.Name}
      </option>
    ))
  ) : (
    <option value="">No Record Exist!</option>
  );
}
